var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('nota_credito_descriptions'))?_c('div',{staticClass:"descriptions"},[_c('hr'),_c('h3',{staticClass:"m-40"},[_vm._v(" Descripciones ")]),_vm._l((_vm.descriptions),function(description){return _c('nc-description',{attrs:{"description":description}})}),_c('btn-add-description')],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }